import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import { CheckboxLabel, IconV2 } from "@bookips/sds";
import * as Collapsible from "@radix-ui/react-collapsible";
import Link from "next/link";
import { useState } from "react";
import { BILLING_TERMS, BILLING_TERMS_MASTER_LABEL } from "../constants/billing";
/**
 * 동의 항목 한 줄
 *
 * 체크박스와 라벨은 하나의 label로 묶어 동의를 토글하고,
 * 화살표는 별도 요소로 분리해 "약관을 보려다 동의되는" 동작을 막는다.
 */ const TermRow = (param)=>{
    let { checked , label , onCheckedChange , arrow , className  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("flex items-start gap-1.5", className),
        children: [
            /*#__PURE__*/ _jsx(CheckboxLabel, {
                checked: checked,
                onCheckedChange: (value)=>onCheckedChange(Boolean(value)),
                classes: {
                    // 라벨이 두 줄로 넘어갈 수 있어 기본 h-6/items-center 대신 상단 정렬한다.
                    root: "h-auto items-start gap-1.5",
                    // 상단 정렬 상태에서 18px 체크박스를 24px(body1 line-height) 첫 줄 높이에 맞춘다.
                    checkbox: "mt-[3px] shrink-0"
                },
                children: label
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex h-6 items-center",
                children: arrow
            })
        ]
    });
};
export const BillingTermsAgreement = (param)=>{
    let { agreements , allChecked , onToggleTerm , onToggleAllTerms  } = param;
    const [open, setOpen] = useState(false);
    // MX-645 — 필수 동의 행 클릭 시. 이 컴포넌트는 월구독 전용이라 Order Type 은 membership 고정이다
    const handleToggleAllTerms = (checked)=>{
        mixpanelEvent("Terms Agreement Clicked", {
            Position: "주문/결제 페이지 결제방법",
            "Is Selected": checked,
            "Order Type": "membership"
        });
        onToggleAllTerms(checked);
    };
    return /*#__PURE__*/ _jsxs(Collapsible.Root, {
        open: open,
        onOpenChange: setOpen,
        className: "flex flex-col gap-2",
        children: [
            /*#__PURE__*/ _jsx(TermRow, {
                checked: allChecked,
                label: BILLING_TERMS_MASTER_LABEL,
                onCheckedChange: handleToggleAllTerms,
                arrow: /*#__PURE__*/ _jsx(Collapsible.Trigger, {
                    "aria-label": open ? "필수 동의 약관 접기" : "필수 동의 약관 펼치기",
                    className: "group flex size-4 items-center justify-center",
                    children: /*#__PURE__*/ _jsx(IconV2.ChevronRight, {
                        size: "xxs",
                        className: "text-secondary transition-transform group-data-[state=open]:rotate-90"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Collapsible.Content, {
                className: cn("overflow-hidden", "data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down"),
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-col gap-2 pl-6",
                    children: BILLING_TERMS.map((param)=>/*#__PURE__*/ {
                        let { key , label , href  } = param;
                        return _jsx(TermRow, {
                            checked: agreements[key],
                            label: label,
                            onCheckedChange: (checked)=>onToggleTerm(key, checked),
                            arrow: /*#__PURE__*/ _jsx(Link, {
                                href: href,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                "aria-label": "".concat(label, " 전문 보기"),
                                className: "flex size-4 items-center justify-center",
                                children: /*#__PURE__*/ _jsx(IconV2.ChevronRight, {
                                    size: "xxs",
                                    className: "text-secondary"
                                })
                            })
                        }, key);
                    })
                })
            })
        ]
    });
};
